import styled from 'styled-components'
import { breakpoints, colors } from './variables'
import { Container } from 'react-bootstrap'

export const StyledMember = styled.main`
  .member-wrap {
    position: relative;
    padding: 6.6rem 0 2rem;
    min-height: 100vh;
    z-index: 1;
  }
  .bg { 
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    .bg-overlay1, .bg-overlay2 {
      position: absolute;
      left: 0;
      width: 60%;
      bottom: 0;
      img {
        width: 100%;
      }
    }
    .bg-overlay1 {
      left: 0%;
    }
    .bg-overlay2 {
      left: 6%;
    }
  } 
  .on-loading{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  .spinner-border {
    width: 2rem;
    height: 2rem;
    margin: 3rem auto 1rem;
  }
`;

export const StyledPanel = styled.div`
  background-color: #fff;
  border-radius: 2px;
  padding: 3rem 6rem 4rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  ${breakpoints.down_md} {
    padding: 2rem 3rem 3rem;
    box-shadow: none;
    margin-left: calc(var(--bs-gutter-x) * -0.5);
    margin-right: calc(var(--bs-gutter-x) * -0.5)
  }
  ${breakpoints.down_sm} {
    padding: 2rem 1.5rem 3rem;
  }
  &.content-panel {
    padding-left: 3rem;
    padding-right: 3rem;
    ${breakpoints.down_md} {
      padding-left: 2rem;
      padding-right: 2rem;
    }
    ${breakpoints.down_md} {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
  .hgroup{
    margin-bottom: 4rem;
    ${breakpoints.down_md} {
      margin-bottom: 1.5rem;
    }
    ${breakpoints.down_sm} {
      margin-bottom: 1.25rem;
    }
    h1 {
      font-size: 2.5rem;
      font-weight: 400;
      margin-bottom: 1rem;
      ${breakpoints.down_md} {
        font-size: 2rem;
        letter-spacing: 1.5px;
        margin-bottom: 0.5rem;
      }
      ${breakpoints.down_md} {
        font-size: 1.5rem;
      }
      &.subject {
        font-size: 1.75rem;
        font-weight: 500;
        ${breakpoints.down_md} {
          font-size: 1.5rem;
        }
      }
    }
    p {
      font-size: 0.9rem;
      font-weight: 400;
      ${breakpoints.down_md} {
        font-size: 0.8rem;
        color: var(--text-color);
      }
    }
  }
  .form-label{
    ${breakpoints.down_md} {
      font-size: 0.9rem;
    }
  }
  .btn-lg{
    font-size: 1rem;
    padding: 0.75rem 1rem;
  }
`;

export const StyledItem = styled.div`
  a {
    text-decoration: none;
  }
  &.item-header{
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--border-color);
    padding: 0 0 1rem 0;
    width: 100%;
    > div {
      font-weight: 500;
      text-align: center;
      &:first-child {
        flex: 1 0 0;
      }
      &:last-child {
        flex: 0 0 120px;
        width: 120px;
      }
    }
  }
  .item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--border-light);
    padding: 1rem .5rem;
    position: relative;
    &:first-of-type {
      ${breakpoints.down_md} {
        border-top: 1px solid var(--border-light);
      }
    }
    &.read {
      background-color: var(--bg-light);
      opacity: .68;
    }
    .item-img {
      width: 88px;
      flex: 0 0 88px;
      img {
        width: 100%;
      }
    }
    .item-content {
      padding-left: 1rem;
      flex: 1 1 auto;
    }
    .subject{
      font-size: 0.875rem;
      border-radius: 3px;
      ${breakpoints.down_md} {
        font-size: 0.75rem;
      }
    }
    .item-date {
      font-size: 1rem;
      padding-left: 1rem;
      color: var(--text-color);
      flex: 0 0 120px;
      max-width: 120px;
      text-align: right;
      ${breakpoints.down_md} {
        max-width: initial;
        text-align: left;
        font-size: 0.875rem;
        margin-top: 0.25rem;
        color: var(--text-light);
      }
    }
    h3 {
      font-size: 1rem;
      margin-bottom: 0;
      color: var(--black);
      font-weight: 400;
    }
    p {
      font-size: 1rem;
      color: var(--text-color);
      margin-bottom: 0;
    }
  }
   .item-serialNo, .item-bindingDate {
    flex: 1 0 0;
    text-align: center;
    ${breakpoints.down_lg} {
      text-align: left;
    }
  }
  .item-starts, .item-endTo {
    flex: 0 0 150px !important;
    width: 150px !important;
    text-align: center;
    ${breakpoints.down_lg} {
      width: 100%;
      text-align: left;
    }
  }
  .item-loss, .item-pay {
    flex: 0 0 100px !important;
    width: 100px !important;
    text-align: center;
    ${breakpoints.down_md} {
      width: 100%;
      text-align: left;
    }
  }
  .item-pay {
    ${breakpoints.down_lg} {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .static-content{
    white-space: normal;
    word-wrap: break-word;
    word-break: break-all;
    .image_resized{
      max-width: 100% !important;
      display: block;
      box-sizing: border-box;
    }
    img{
      max-width: 100%;
    }
    table {
      border-collapse: collapse;
      margin: 25px 0;
      font-family: sans-serif;
      width: 100%;
    }
    figure{
      margin: 0;
      &.table {
        width: 100%;
        overflow: auto;
      }
      &.media{
        display: block;
      }
    }
  }
`;
